import { createSlice } from "@reduxjs/toolkit";

export const catalogSessionSlice = createSlice({
  name: "catalogSession",
  initialState: { epoch: 0 },
  reducers: {
    bumpCatalogEpoch: (state) => {
      state.epoch += 1;
    },
  },
});

export const { bumpCatalogEpoch } = catalogSessionSlice.actions;

export default catalogSessionSlice.reducer;
